import { withLocationsByProductGridCustom } from './HOCs/withLocationsByProductGridCustom';

export default {
    name: 'warehouseLocationsWithProductsPage',
    before: [],
    after: [],
    setup: (app) => {
        const routeName = 'warehouseLocationsProducts';
        const route = app.routes.getItem(routeName);
        if (route) {
            const routeProps = route.props;

            route.props = (state) => ({
                ...routeProps(state),
                // Can be removed after core release, just confirm that props are match to core ones
                productDetailsStockPageRoute: '/products/stock',
                permissions: {
                    withExport: true,
                    canActivate: true,
                    canDeactivate: true,
                    canPrint: true,
                    canCycleCount: true,
                    canAdjust: true,
                    canAddStockReservation: true,
                    withProductStockLink: true,
                },
            });

            route.render = withLocationsByProductGridCustom(app);
            app.routes.changeItem(routeName, route);
        }
    },
};
